import { Component, OnInit, Inject } from '@angular/core';
import { UsersService } from "../services/users/users.service";
import { MatDialog } from '@angular/material';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import { Router } from '@angular/router';
import { TokenStorage } from '../auth/token.storage';
import { StoreUserDetails } from '../auth/storeuserdetails';
import { NotificationService } from '../services/notification/notification.service';
import { MessagingService } from '../shared/messaging.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { ErrorExcelUpload } from '../pages/schedulingandplanning/schedulingandplanning.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  userName: string;
  password: string;
  loginError: boolean = false;
  loginErrorMessage: string;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private userservice: UsersService,
    public tokenStorage: TokenStorage,
    public userDetails: StoreUserDetails,
    private notificationService: NotificationService,
    private messagingService: MessagingService,
    private permissionsService: NgxPermissionsService

  ) { }

  openDialog() {
    let dialogRef = this.dialog.open(ForgotpasswordComponent, {
      width: '600px',

    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  loginUser() {
    let token;
    let loginData = {
      username: this.userName,
      password: this.password
    }

    if (this.userName === undefined || this.password === undefined) {
      this.loginError = true;
      this.loginErrorMessage = "Username/Password cannot be empty."
    } else {

      this.userservice.makeLogin(loginData).subscribe(res => {
        this.router.navigate(['/']);
        this.userDetails.saveUser(this.userName);
        this.tokenStorage.saveToken(res);
      /*   if (this.messagingService.token) {
          this.notificationService.subscribeToTopic(this.messagingService.token).subscribe(res => {
          });
        } */

        if (this.tokenStorage.getTenant() === 'ph-reta-prod' ||
            this.tokenStorage.getTenant() === 'ph-reta-test' ||
            this.tokenStorage.getTenant() === 'imagesense-reta-prod' ||
            this.tokenStorage.getTenant() === 'agd-reta-prod' ||
            this.tokenStorage.getTenant() === 'vijaya-reta-prod') {
                      
          this.tokenStorage.saveCustomerType("CUSTOMER_TYPE", "Diagnostic");        
        }

        if (this.userName.substring(0, 6) === 'admin_') {
          let permissions = [];
          permissions.push('Admin');
          this.permissionsService.loadPermissions(permissions);
          this.router.navigate(['/']);
        }
        else {
          this.userservice.getRolesByUsers().subscribe(allRoles => {
            let permissions = [];
            if (allRoles.length != 0) {
              if (allRoles[allRoles.length - 1].roleName === 'Delivery_Associate' || allRoles[allRoles.length - 1].roleName === 'Marketing') {
                window.sessionStorage.removeItem('AuthToken');
                window.sessionStorage.clear();
                this.router.navigateByUrl('login');
                const openDialog = this.dialog.open(ErrorExcelUpload, {
                  width: '450px',
                  data: {
                    Result: "You don't have permissions to access this."}
                });
              }
              else {
                permissions.push(allRoles[allRoles.length - 1].roleName);
                //  localStorage.setItem('permissions', JSON.stringify(permissions));
                window.sessionStorage.setItem('permissions', JSON.stringify(permissions))
                this.permissionsService.loadPermissions(permissions);
                this.router.navigate(['/']);
              }
            }
          },
            Error => {
              window.sessionStorage.removeItem('AuthToken');
              window.sessionStorage.clear();
              this.router.navigateByUrl('login');
              const openDialog = this.dialog.open(ErrorExcelUpload, {
                width: '450px',
                data: {
                  Result: "You don't have any role assigned into the system please contact your admin."
                }
                });
            });
        }
      }, Error => {
        this.loginError = true;
        this.loginErrorMessage = "Invalid Login."; // this error message will be send by backend
        console.log("Error", Error);
      });
    }
  }

  ngOnInit() {
  }

}